<template>
    <div class="home">
        <b-button v-if="kartiste" style="margin: 10px" @click="belgeiste('kart')" variant="danger">Yeni Esir Kartı Al
        </b-button>
        <b-button v-if="mektupiste" style="margin: 10px" @click="belgeiste('mektup')" variant="danger">Yeni Mektup Al
        </b-button>

        <b-jumbotron v-if="kisi.telegramId===0">
            Telegram kaydınız yapılmamış. <br/>Telegramdan <a href="https://t.me/kizilay_bot">@kizilay_bot</a> adresine
            <b>
                <b-icon @click="copy_guid" icon="documents"></b-icon>
                <span @click="copy_guid" id="guid">{{kisi.guid}}</span></b> mesajın göndermeniz gerekiyor.
        </b-jumbotron>

        <div v-if="yoneticiRaporGoster">
            <b-jumbotron class="my-auto">

                <h5 style="margin-bottom: 2em;">
                    <b style="color: darkblue;">{{data.toplamMektupSayisi | formatNumber | replaceComma}}</b> adet
                    <span style="font-weight: bolder">Esir Mektubundan</span>
                    <b style="color: darkgreen;"> {{data.tamamlananMektupSayisi | formatNumber | replaceComma}}</b>
                    adedi tamamlanmış olup,
                    <b style="color: darkred;">{{data.onayaGonderilenMektupSayisi | formatNumber | replaceComma}}</b>
                    adedi tashih edilmeyi beklemektedir.
                </h5>
                <h5>
                    <b style="color: darkblue;">{{data.toplamEsirKartiSayisi | formatNumber | replaceComma}}</b> adet
                    <span style="font-weight:bolder;">Esir Kartından</span>
                    <b style="color: darkgreen; "> {{data.tamamlananEsirKartiSayisi | formatNumber | replaceComma}}</b>
                    adedi tamamlanmış olup,
                    <b style="color: darkred; ">{{data.onayaGonderilenKartSayisi | formatNumber | replaceComma}}</b>
                    adedi tashih edilmeyi beklemektedir.
                </h5>
            </b-jumbotron>
        </div>


        <div class="telefon-alani-navbar pl-5" style="text-align: left; overflow: scroll;">
            <b-navbar-nav>

                <b-nav-item v-if="kisi.mektupOperator" v-on:click="belgeiste($event,'mektup')"
                            exact-active-class="active">
                    Mektup İste
                    <b-icon class="float-right pr-5" icon="chevron-right"></b-icon>
                </b-nav-item>
                <b-nav-item v-if="kisi.mektupEditor" v-on:click="belgeiste($event,'mektup',true)"
                            exact-active-class="active">
                    Tashih için Mektup İste
                    <b-icon class="float-right pr-5" icon="chevron-right"></b-icon>
                </b-nav-item>

                <b-nav-item v-if="kisi.kartOperator" v-on:click="belgeiste($event,'kart')" exact-active-class="active">
                    Kart İste
                    <b-icon class="float-right pr-5" icon="chevron-right"></b-icon>
                </b-nav-item>
                <b-nav-item v-if="kisi.kartEditor" v-on:click="belgeiste($event,'kart',true)"
                            exact-active-class="active">
                    Tashih İçin Kart İste
                    <b-icon class="float-right pr-5" icon="chevron-right"></b-icon>
                </b-nav-item>

                <b-nav-item v-if="kisi.mektupEditor || kisi.mektupOperator"
                            :to="{name: 'belgeler',query:{ne:'sahsi', tur:'mektup'}}" exact-active-class="active">
                    Mektuplarım
                    <b-icon class="float-right pr-5" icon="chevron-right"></b-icon>
                </b-nav-item>


                <b-nav-item v-if="kisi.kartEditor || kisi.kartOperator"
                            :to="{name: 'belgeler',query:{ne:'sahsi', tur:'kart'}}" exact-active-class="active">
                    Kartlarım
                    <b-icon class="float-right pr-5" icon="chevron-right"></b-icon>
                </b-nav-item>

            </b-navbar-nav>
        </div>


    </div>
</template>

<script>
    import 'vue-simple-suggest/dist/styles.css'
    import {iste} from "@/api/iste";
    import {GoogleTokenIleGirisYapmayiDene} from "@/utils/googlegiris";
    import {mapGetters} from "vuex";
    import {GenelRapor} from "@/api/kisi";
    import NavItems from "@/components/NavItems";

    export default {
        name: "anasayfa",
        data() {
            return {
                yoneticiRaporGoster: false,
                mektupiste: false,
                kartiste: false,
                data: ''
            }
        },
        computed: {
            ...mapGetters([
                'bkCount', 'kisi', 'girisYapmismi', 'mektupMenusuGoster', 'kartMenusuGoster', 'mektupIsteGoster', 'kartIsteGoster'
            ])
        },
        methods: {
            async belgeiste(e, tur, tashihMi = false) {
                e.preventDefault();
                await iste(this, tur, tashihMi);
            },
            copy_guid() {
                const copyText = document.getElementById("guid");
                const textArea = document.createElement("textarea");
                textArea.value = copyText.textContent;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand("Copy");
                textArea.remove();

                this.$notify({
                    group: 'ust',
                    text: 'Kopyalandı'
                });
            }
        },
        async mounted() {
            const that = this;
            if (!this.girisYapmismi) {
                await new GoogleTokenIleGirisYapmayiDene(this);
            }

            if (!this.girisYapmismi) {
                this.mesaj = "Giriş yapmanız lazım";
                setTimeout(function () {
                    that.$router.push("/giris-yap?url=" + encodeURI("/"))
                }, 1000);
                return
            }

            const gelen = await GenelRapor();
            if (gelen.hataVarMi) {

                if (gelen.kod === "giris-yap") {
                    await that.$router.push("/giris-yap?url=" + encodeURI(gelen.data));
                    return
                }
                this.mesaj = gelen.mesaj;
                return;
            }

            if (gelen.kod === "yonlen") {
                await this.$router.push(gelen.data);
                return;
            }
            if (gelen.kod == "yoneticirapor") {
                this.data = gelen.data;
                this.yoneticiRaporGoster = true;
            }
            if (gelen.kod == "mektupvekartiste") {
                this.mektupiste = true;
                this.kartiste = true;
            }
            if (gelen.kod == "kartiste") {
                this.kartiste = true;
            }
            if (gelen.kod == "mektupiste") {
                this.mektupiste = true;
            }
        }
        ,
        created() {

        }
        ,
        components: {}
        ,
    }
</script>

<style lang="scss" scoped>
    .telefon-alani-navbar {
        display: none;
        background: lightgray;

        @media (max-width: 500px) {
            display: block;
        }
    }
</style>